import {JsonProperty} from '@hyperloris/tyson';
import {Account} from './account';
import {DateTime} from 'luxon';
import {Trade} from './trade';
import {CommRate} from '../billing/comm-rate';
import {IBrokerageRelated} from './i-brokerage-related';
import {AccountDefinition} from '../customer/account-definition';
import {TreeNode} from 'primeng/api';
import {ClearingInfo} from "./clearing-info";
import FeeStatus = IBrokerageRelated.FeeStatus;
import {Clearing} from "./clearing";

export class Order implements TreeNode {

  @JsonProperty()
  id: string = undefined;

  @JsonProperty()
  exchangeOrderId: string = undefined;

  @JsonProperty()
  parentId: string = undefined;

  @JsonProperty()
  contractCode: string = undefined;

  @JsonProperty()
  contractVersion: string = undefined;

  @JsonProperty()
  exchangeCode: string = undefined;

  @JsonProperty()
  side: Trade.Side = undefined;

  @JsonProperty()
  strategy: Order.Strategy = Order.Strategy.NONE;

  @JsonProperty()
  price: number = undefined;

  @JsonProperty()
  avgPriceManaged: boolean = undefined;

  @JsonProperty()
  avgPrice: number = undefined;

  @JsonProperty()
  overrideAvgPrice: number = 0;

  @JsonProperty()
  avgPriceResidual: number = 0;
  @JsonProperty()
  avgPriceResidualGroup: number = 0;
  @JsonProperty()
  avgPriceResidualAlloc: number = 0;

  @JsonProperty()
  avgRndPrice: number = 0;

  @JsonProperty()
  avgPriceResidualCurrency: string = undefined;

  @JsonProperty()
  avgPriceGroupId: string = undefined;

  @JsonProperty()
  volume: number = undefined;

  @JsonProperty()
  unmatchedVolume: number = undefined;

  @JsonProperty()
  reference: string = undefined;

  @JsonProperty()
  account: Account;

  @JsonProperty()
  customerName: string = undefined;

  @JsonProperty()
  isChecked: boolean = false;

  @JsonProperty()
  isDisabled: boolean = false;

  @JsonProperty()
  executionFee: string = undefined;

  openClose: AccountDefinition.OpenClose = AccountDefinition.OpenClose.NO;

  state: Order.OrderState = Order.OrderState.READY;

  @JsonProperty()
  businessDate: Date = new Date();

  @JsonProperty()
  clearingDate: Date = new Date();

  @JsonProperty()
  maturity: string = undefined;

  callPut: Trade.CallPut = Trade.CallPut.NONE;

  @JsonProperty()
  strike: number = undefined;

  @JsonProperty()
  giveIn: boolean = undefined;

  @JsonProperty()
  giveInBrokerCode: string = undefined;

  @JsonProperty()
  giveInMessage: string = undefined;

  @JsonProperty()
  giveInMessage2: string = undefined;

  @JsonProperty()
  giveInMessage3: string = undefined;

  @JsonProperty()
  giveInCommission: string = undefined;

  @JsonProperty()
  giveUp: boolean = undefined;

  @JsonProperty()
  giveUpBrokerCode: string = undefined;

  @JsonProperty()
  giveUpMessage: string = undefined;

  @JsonProperty()
  giveUpMessage2: string = undefined;

  @JsonProperty()
  giveUpMessage3: string = undefined;

  @JsonProperty()
  giveUpAccountType: string = undefined;

  @JsonProperty()
  giveUpCommission: string = undefined;

  @JsonProperty()
  source: string = undefined;

  @JsonProperty()
  operator: string = undefined;

  @JsonProperty()
  trader: string = undefined;

  @JsonProperty()
  owner: string = undefined;

  @JsonProperty()
  ownerCode: string = undefined;

  @JsonProperty()
  type: string = undefined;

  @JsonProperty()
  clearingBroker: string = undefined;

  @JsonProperty()
  creationDate: Date = new Date();

  @JsonProperty()
  modificationDate: Date = new Date();

  @JsonProperty()
  comment: string = undefined;

  @JsonProperty()
  freeText1: string = undefined;

  @JsonProperty()
  freeText2: string = undefined;

  @JsonProperty()
  executionDate: Date = new Date();

  @JsonProperty()
  alertText: string = undefined;

  @JsonProperty()
  jobOut: boolean = false;

  @JsonProperty()
  tradingEnvironment: string = undefined;

  @JsonProperty()
  tradeType: string = undefined;

  @JsonProperty()
  clientOrderId: string = undefined;

  @JsonProperty()
  clearingHouse: string = undefined;

  @JsonProperty()
  customOrderReference: string = undefined;

  @JsonProperty()
  submittingTrader: string = undefined;

  @JsonProperty()
  desk: string = undefined;
  @JsonProperty()
  forceClear: boolean;

  @JsonProperty()
  customFreeTextField1: string = undefined;

  @JsonProperty()
  customFreeTextField2: string = undefined;

  @JsonProperty()
  customFreeTextField3: string = undefined;

  @JsonProperty()
  customFreeTextField4: string = undefined;

  @JsonProperty()
  brokerageFee: number = undefined;

  @JsonProperty()
  overrideBrokerageFee: number = undefined;

  @JsonProperty()
  brokerageOverridden: boolean = false;

  @JsonProperty()
  brokerageOverrideReason: string = undefined;

  @JsonProperty()
  brokerageCurrency: string = undefined;

  @JsonProperty()
  brokerageRateAmount: number;

  @JsonProperty()
  overrideBrokerageRateAmount: number;

  @JsonProperty()
  brokerageDate: DateTime;

  @JsonProperty()
  brokerageRule: CommRate.RuleType;

  @JsonProperty()
  alreadyPaidElsewhere: boolean;

  @JsonProperty()
  thirdPartySystemFeeStatus: IBrokerageRelated.FeeStatus = FeeStatus.NOT_APPLICABLE;

  @JsonProperty()
  thirdPartySystemFeeRejectReason: string = undefined;

  @JsonProperty()
  unknownAccount: boolean = false;

  @JsonProperty()
  contractUnit: string = undefined;

  @JsonProperty()
  contractSize: number = 1;

  @JsonProperty()
  invoiceId: number = 0;

  @JsonProperty()
  invoiceNumber: string;

  @JsonProperty()
  settlementId: number = 0;

  @JsonProperty()
  manualInvoiceRemoved: boolean = false;

  @JsonProperty()
  broker: string | undefined;

  @JsonProperty()
  obLegRank: number;

  @JsonProperty()
  complexStrategy: string | undefined;

  @JsonProperty()
  clearings: Clearing[];

  @JsonProperty()
  clearingInfo: ClearingInfo | undefined;

}

export module Order {
  export enum OrderState {
    READY = 'READY',
    WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL',
    DISABLED = 'DISABLED',
    APSOVERRIDE = 'APSOVERRIDE',
    WORKING_ORDER = 'WORKING_ORDER',
    ALERT_CHECK = 'ALERT_CHECK'
  }

  export enum Strategy {
    NONE = 'NONE',
    SPREAD = 'SPREAD',
    CONDOR = 'CONDOR',
    BUTTERFLY = 'BUTTERFLY',
    STRADDLE = 'STRADDLE',
    STRANGLE = 'STRANGLE'
  }
}
